const translations = {
  "en": {
    "Current Plan": "Current Plan",
    "Get it": "Get it",
    "Manage Subscriptions": "Manage Subscriptions",
    "Pricing": "Pricing",
    "Subscriptions": "Subscriptions"
  },
  "zh-tw": {
    "Current Plan": "目前方案",
    "Get it": "取得",
    "Manage Subscriptions": "管理訂閱",
    "Pricing": "定價",
    "Subscriptions": "訂閱"
  }
};

export default translations;
